import React from "react";

// Logo de Olimpo. variant "full" = lockup completo (casco + OLIMPO web) para pantallas centradas.
// variant "mark" = casco + palabra OLIMPO, compacto para encabezados.
export const Logo = ({ variant = "mark", height, className = "", onClick }) => {
  if (variant === "full") {
    return (
      <img
        src="/olimpo-logo.png"
        alt="Olimpo"
        onClick={onClick}
        className={className}
        style={{ height: height || 132, width: "auto" }}
        data-testid="olimpo-logo"
      />
    );
  }
  return (
    <div
      onClick={onClick}
      className={`flex items-center gap-2.5 ${onClick ? "cursor-pointer" : ""} ${className}`}
      data-testid="olimpo-logo"
    >
      <img src="/olimpo-helmet.png" alt="Olimpo" style={{ height: height || 28, width: "auto" }} />
      <span className="mono-label text-dorado" style={{ letterSpacing: "0.3em" }}>OLIMPO</span>
    </div>
  );
};

export default Logo;
